import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../config/api";

export const saveConsentDB = createAsyncThunk(
  "consent/save",
  async (data) => {
    const response = await api.post("/consent", data);
    return response.data;
  }
);
